import React from "react";
import { motion } from "framer-motion";
import News from "./News";
import { backButton, contentSlideUp, parent, transition } from "@services/motionTransitions";

type ArticlesType = {
  articles: any[];
  loadMoreCallback: Function;
  loading: Boolean;
};

const Articles: React.FC<ArticlesType> = ({ articles, loadMoreCallback, loading }) => {
  return (
    <section>
      <motion.div className="space-y-6 sm:space-y-12" variants={parent} animate="animate" initial="initial">
        <motion.div className="grid grid-cols-1 justify-center gap-6 sm:grid-cols-2 lg:grid-cols-3" variants={parent} animate="animate" initial="initial">
          {articles.map((article, key) => {
            try {
              if (article.fields) {
                const titre: string = article.fields.titre;
                const slug: string = article.fields.slug;
                const imageUrl = article.fields.couverture ? article.fields.couverture.fields.file.url : undefined;
                const date = article.fields.date;
                const description: string = article.fields.description;
                return (
                  <motion.div key={key} variants={contentSlideUp} transition={transition}>
                    <News titre={titre} slug={slug} img={imageUrl} date={date} description={description} />
                  </motion.div>
                );
              }
            } catch (ex) {
              throw new Error(`Error while fetching news (on news page) : ${ex}`);
            }
          })}
        </motion.div>
        <motion.div className="flex justify-center">
          <motion.button variants={contentSlideUp} transition={transition} onClick={loadMoreCallback()} className="inline-flex transform items-center rounded bg-whiteAccent px-4 py-2 text-sm font-medium text-blackAccent transition duration-300 hover:underline">
            {loading && (
              <svg className="mr-3 h-5 w-5 animate-spin text-blackAccent" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.944 12.979c-.489 4.509-4.306 8.021-8.944 8.021-2.698 0-5.112-1.194-6.763-3.075l1.245-1.633c1.283 1.645 3.276 2.708 5.518 2.708 3.526 0 6.444-2.624 6.923-6.021h-2.923l4-5.25 4 5.25h-3.056zm-15.864-1.979c.487-3.387 3.4-6 6.92-6 2.237 0 4.228 1.059 5.51 2.698l1.244-1.632c-1.65-1.876-4.061-3.066-6.754-3.066-4.632 0-8.443 3.501-8.941 8h-3.059l4 5.25 4-5.25h-2.92z" />
              </svg>
            )}
            Charger les articles plus anciens
          </motion.button>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Articles;
